import { getObjectPaths } from "../pathTree.mjs";
import { isValidQSType } from "../types.mjs";
import { convertValue } from './convertValue.mjs';
import get from 'lodash/get.js';
import set from 'lodash/set.js';
import has from 'lodash/has.js';
import cloneDeep from 'lodash/cloneDeep.js';
export function convert(qsObj, { definedTuples = false, typeDef, typeDefsFromInitial = false, filterToTypeDef = false }) {
    let dataTypes = getPathTypes(typeDef, definedTuples);
    let paths = getObjectPaths(qsObj, definedTuples);
    let convertedObj = typeDefsFromInitial ? cloneDeep(qsObj) : {};
    if (filterToTypeDef)
        paths = getObjectPaths(typeDef, definedTuples);
    for (let propPath of paths) {
        let joinedPath = propPath.join('.');
        let value = get(qsObj, propPath, undefined);
        if (typeof value === 'undefined' && !qsObj.hasOwnProperty(propPath[0])) {
            continue;
        }
        if (value === '' || typeof value === 'undefined') {
            let keyToSearch = joinedPath + '.';
            let found = false;
            for (const key of dataTypes.keys()) {
                if (key.indexOf(keyToSearch) === 0) {
                    found = true;
                    break;
                }
            }
            if (found) {
                set(convertedObj, propPath, null);
                continue;
            }
        }
        if ((value === '' || typeof value === 'undefined') && filterToTypeDef) {
            let curPath = [], curIdx = 0;
            do {
                curPath = propPath.slice(0, propPath.length - (curIdx++));
                if (curPath.length && has(qsObj, curPath)) {
                    break;
                }
            } while (curPath.length > 1);
            if (curPath.length && curPath.length !== propPath.length) {
                set(convertedObj, curPath, null);
                continue;
            }
        }
        if (typeof value !== 'undefined') {
            let definedType = dataTypes.get(joinedPath) ?? (typeDefsFromInitial ? 'any' : undefined);
            if (definedType) {
                let newValue = convertValue(value, definedType);
                if (typeof newValue !== 'undefined')
                    set(convertedObj, propPath, newValue);
            }
            else if (value === null) {
                set(convertedObj, propPath, '');
            }
        }
    }
    return convertedObj;
}
function getPathTypes(typeDef, definedTuples) {
    let result = new Map();
    let paths = getObjectPaths(typeDef, definedTuples);
    for (let propPath of paths) {
        let joinedPath = propPath.join('.');
        let varType = get(typeDef, propPath);
        if (!isValidQSType(varType)) {
            throw new Error(`Path definition is invalid - ${joinedPath} cannot be ${varType}`);
        }
        result.set(joinedPath, varType);
    }
    return result;
}
